import Button from '@r1-frontend/ui-react/components/buttons/button';
import { DescribedCost } from '@r1-frontend/ui-react/components/costs';
import Stepper from '@r1-frontend/ui-react/components/Stepper';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { TRouterCardProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const SteppableCardFooter = ({
    title,

    disabled = false,
    isTestDrive = false,

    cost,
    previousCost,
    period,

    quantity,

    btnText,

    onButtonClick,
    onIncrement,
    onDecrement,
    onCostClick,
}: Omit<TRouterCardProps, 'images' | 'description' | 'characteristics' | 'Label'>): JSX.Element => {
    return (
        <ListContainer $size={16} $direction={'column'}>
            <div>
                <H4 $withIndent={false}>{title}</H4>
                <DescribedCost
                    data-test={'RouterCard_cost'}
                    installmentPeriod={period}
                    onClick={quantity && quantity > 0 ? onCostClick : undefined}
                    isTestDrive={isTestDrive}
                    previousCost={previousCost}
                >
                    {cost}
                </DescribedCost>
            </div>
            {quantity
                ? !isTestDrive && (
                    <Stepper
                        min={0}
                        summaryLimitsReached={disabled}
                        onIncrement={onIncrement}
                        onDecrement={onDecrement}
                        value={quantity}
                        $bgColor={COLORS.ButtonPrimary}
                        $color={COLORS.TextWhite}
                    />
                )
                : <Button
                    bType={'secondary'}
                    size={'medium'}
                    onClick={onButtonClick}
                    data-test={'RouterCard_onAdd'}
                    disabled={disabled}
                >
                    {btnText || 'Добавить'}
                </Button>
            }
        </ListContainer>
    );
};

export default SteppableCardFooter;
